import Wrapper from './_views/Wrapper.vue';

const parentRouteConfig = {
  name: 'Orders',
  to: {
    name: 'orders',
    query: {
      pageNum: '1',
      suffix: '',
    },
  },
};

export default [
  {
    path: '/orders',
    component: Wrapper,
    children: [
      {
        path: '',
        name: 'orders',
        component: () => import(/* webpackChunkName: "orders" */ './_views/KernelOrders.vue'),
        meta: {
          title: 'Orders',
          navigation: {
            position: 1,
            name: 'Orders',
            icon: 'shopping_cart',
            specialQueries: ['suffix'],
            to: {
              name: 'orders',
              query: {
                suffix: '',
                pageNum: '1',
              },
            },
          },
        },
      },
      {
        path: ':id',
        name: 'order',
        component: () => import(/* webpackChunkName: "order" */ './_views/KernelOrder.vue'),
        meta: {
          title: 'Order details',
          parent: parentRouteConfig,
        },
      },
    ],
  },
];
